import { fetchExchangeRates } from '@/services/onesimpleapi';

const onesimpleapi = {
  state: {
    usdToEurExchangeRate: null,
    gbpToEurExchangeRate: null,
  },

  mutations: {
    setUSDtoEURExchangeRate(state, exchangeRate) {
      state.usdToEurExchangeRate = exchangeRate;
    },
    setGBPtoEURExchangeRate(state, exchangeRate) {
      state.gbpToEurExchangeRate = exchangeRate;
    },
  },

  actions: {
    async fetchExchangeRates({ commit }) {
      try {
        const rates = await fetchExchangeRates();
        commit('setUSDtoEURExchangeRate', rates.usdToEur);
        commit('setGBPtoEURExchangeRate', rates.gbpToEur);
        return rates;
      } catch (error) {
        console.error('Error fetching exchange rates:', error);
        throw new Error('Failed to fetch exchange rates.');
      }
    },
  },

  getters: {
    usdToEurExchangeRate: (state) => state.usdToEurExchangeRate,
    gbpToEurExchangeRate: (state) => state.gbpToEurExchangeRate,
  },
};

export default onesimpleapi;
